/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const scheduleOverrideSchema = z.object({
	from: z.string(),
	to: z.string(),
	open: z.boolean(),
	start: z.string().nullable(),
	end: z.string().nullable(),
})

export type ScheduleOverrideSchema = z.infer<typeof scheduleOverrideSchema>
